import { useEffect, useState } from 'preact/hooks';
import { websApi } from '@/api/webs';
export function useConferenceSync({ web, hasBigMarker, setWeb }) {
    const [syncing, setSyncing] = useState(false);
    useEffect(() => {
        if (!web || !web.OnlineEvent?.ConferenceId || !hasBigMarker || web.OnlineEvent.ConferenceNotFound)
            return;
        let active = true;
        const { WorkspaceId, Id } = web;
        (async () => {
            setSyncing(true);
            try {
                const res = await websApi.syncConference(WorkspaceId, Id);
                if (!active)
                    return;
                if (res.data)
                    setWeb(res.data);
            }
            finally {
                if (active)
                    setSyncing(false);
            }
        })();
        return () => { active = false; };
    }, [web?.Id, web?.WorkspaceId, web?.OnlineEvent?.ConferenceId, hasBigMarker]);
    return { syncing };
}
